import React from 'react';
import { useAppSelector } from 'store/hooks';

import { getLessonCategories } from 'store/lesson-categories/actions';
import { lessonCategoriesSelector } from 'store/lesson-categories/selectors';

import { usePagination } from 'hooks/usePagination';

import { DefaultModal } from 'components/DefaultModal';

import { useLessonCategories } from './LessonCategoriesPage.hooks';

import LessonCategoriesPage from './LessonCategoriesPage';

const LessonCategoriesPageContainer = () => {
  const lessonCategories = useAppSelector(lessonCategoriesSelector);

  const {
    loading,
    removeConfirmOpen,
    sortParams,
    removeConfirmData,
    closeRemoveConfirm,
    onSortChange,
    onCategoryRowClick,
    onCategoryEditClick,
    onCategoryRemoveClick,
    onConfirmRemoveClick,
    onCategoryCreateClick,
  } = useLessonCategories({
    categoriesPerPage: lessonCategories.perPage,
  });

  const [onPerPageChange, onPrevPageClick, onNextPageClick] = usePagination({
    dataAction: getLessonCategories,
    currentPage: lessonCategories.currentPage,
    totalPages: lessonCategories.totalPages,
    perPage: lessonCategories.perPage,
    sortBy: sortParams.sortBy,
    sortDirection: sortParams.sortDirection,
  });

  return (
    <>
      <LessonCategoriesPage
        loading={loading}
        categories={lessonCategories.data}
        sortParams={sortParams}
        currentPage={lessonCategories.currentPage}
        totalPages={lessonCategories.totalPages}
        perPage={lessonCategories.perPage}
        onSortChange={onSortChange}
        onPerPageChange={onPerPageChange}
        onPrevPageClick={onPrevPageClick}
        onNextPageClick={onNextPageClick}
        onCategoryRowClick={onCategoryRowClick}
        onCategoryEditClick={onCategoryEditClick}
        onCategoryRemoveClick={onCategoryRemoveClick}
        onCategoryCreateClick={onCategoryCreateClick}
      />
      <DefaultModal
        {...removeConfirmData}
        open={removeConfirmOpen}
        confirmText="Yes, remove"
        onConfirmClick={onConfirmRemoveClick}
        onCancelClick={closeRemoveConfirm}
        onClose={closeRemoveConfirm}
      />
    </>
  );
};

export default LessonCategoriesPageContainer;
